import { render } from "./CometChatNavBar.vue?vue&type=template&id=34c90364&scoped=true"
import script from "./CometChatNavBar.vue?vue&type=script&lang=js"
export * from "./CometChatNavBar.vue?vue&type=script&lang=js"

import "./CometChatNavBar.vue?vue&type=style&index=0&id=34c90364&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c90364"]])

export default __exports__